const filterByCategory = (
  data: (Queries.kontent_item_article_page_news | Queries.kontent_item_event)[],
  key: string,
  categories: string[],
): Queries.kontent_item[] => {
  let filteredData: (Queries.kontent_item_article_page_news | Queries.kontent_item_event)[] = [];
  data.forEach((node) => filteredData.push(node));

  filteredData = filteredData.filter((el) => {
    let filterObj = false;

    el?.elements?.[key]?.value?.forEach((cat: { codename: string }) => {
      if (categories.includes(cat.codename)) {
        filterObj = true;
      }
    });

    return filterObj;
  });

  return filteredData;
};

export default filterByCategory;
